export const POST_NEW_PARTICIPANT = "POST_NEW_PARTICIPANT";
export const POST_NEW_PARTICIPANT_SUCCESS = "POST_NEW_PARTICIPANT_SUCCESS";
export const POST_NEW_PARTICIPANT_FAIL = "POST_NEW_PARTICIPANT_FAIL";

export const GET_PARTICIPANTS = "GET_PARTICIPANTS";
export const GET_PARTICIPANTS_SUCCESS = "GET_PARTICIPANTS_SUCCESS";
export const GET_PARTICIPANTS_FAIL = "GET_PARTICIPANTS_FAIL";

export const GET_PARTICIPANT_DETAIL = "GET_PARTICIPANT_DETAIL";
export const GET_PARTICIPANT_DETAIL_SUCCESS = "GET_PARTICIPANT_DETAIL_SUCCESS";
export const GET_PARTICIPANT_DETAIL_FAIL = "GET_PARTICIPANT_DETAIL_FAIL";

export const DELETE_USER = "DELETE_USER";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAIL = "DELETE_USER_FAIL";

export const DELETE_DOC = "DELETE_DOC";
export const DELETE_DOC_SUCCESS = "DELETE_DOC_SUCCESS";
export const DELETE_DOC_FAIL = "DELETE_DOC_FAIL";

export const POST_PARTICIPANT_DOC = "POST_PARTICIPANT_DOC";
export const POST_PARTICIPANT_DOC_SUCCESS = "POST_PARTICIPANT_DOC_SUCCESS";
export const POST_PARTICIPANT_DOC_FAIL = "POST_PARTICIPANT_DOC_FAIL";

export const POST_UPDATE_PARTICIPANT = "POST_UPDATE_PARTICIPANT";
export const POST_UPDATE_PARTICIPANT_SUCCESS = "POST_UPDATE_PARTICIPANT_SUCCESS";
export const POST_UPDATE_PARTICIPANT_FAIL = "POST_UPDATE_PARTICIPANT_FAIL";

export const GET_PARTICIPANT_DOC = "GET_PARTICIPANT_DOC";
export const GET_PARTICIPANT_DOC_SUCCESS = "GET_PARTICIPANT_DOC_SUCCESS";
export const GET_PARTICIPANT_DOC_FAIL = "GET_PARTICIPANT_DOC_FAIL";

export const UPDATE_PARTICIPANT_PIC = "UPDATE_PARTICIPANT_PIC";
export const UPDATE_PARTICIPANT_PIC_SUCCESS = "UPDATE_PARTICIPANT_PIC_SUCCESS";
export const UPDATE_PARTICIPANT_PIC_FAIL = "UPDATE_PARTICIPANT_PIC_FAIL";

export const SHOW_HIDE_DOC = "SHOW_HIDE_DOC";
export const SHOW_HIDE_DOC_SUCCESS = "SHOW_HIDE_DOC_SUCCESS";
export const SHOW_HIDE_DOC_FAIL = "SHOW_HIDE_DOC_FAIL";

export const PARTICIPANT_CALENDER_DATA = "PARTICIPANT_CALENDER_DATA";
export const PARTICIPANT_CALENDER_DATA_SUCCESS = "PARTICIPANT_CALENDER_DATA_SUCCESS";
export const PARTICIPANT_CALENDER_DATA_FAIL = "PARTICIPANT_CALENDER_DATA_FAIL";

export const SET_PART_STATE = "SET_PART_STATE";
export const SET_PART_STATE_SUCCESS = "SET_PART_STATE_SUCCESS";
export const SET_PART_STATE_FAIL = "SET_PART_STATE_FAIL";

export const DELETE_DESCRIPTION = "DELETE_DESCRIPTION";
export const DELETE_DESCRIPTION_SUCCESS = "DELETE_DESCRIPTION_SUCCESS";
export const DELETE_DESCRIPTION_FAIL = "DELETE_DESCRIPTION_FAIL";

export const PARTICIPANTS_LOCATION_ASSIGNEES = "PARTICIPANTS_LOCATION_ASSIGNEES";
export const PARTICIPANTS_LOCATION_ASSIGNEES_SUCCESS = "PARTICIPANTS_LOCATION_ASSIGNEES_SUCCESS";
export const PARTICIPANTS_LOCATION_ASSIGNEES_FAIL = "PARTICIPANTS_LOCATION_ASSIGNEES_FAIL";

export const PARTICIPANT_DETAILS_FOR_TASK = "PARTICIPANT_DETAILS_FOR_TASK";
export const PARTICIPANT_DETAILS_FOR_TASK_SUCCESS = "PARTICIPANT_DETAILS_FOR_TASK_SUCCESS";
export const PARTICIPANT_DETAILS_FOR_TASK_FAIL = "PARTICIPANT_DETAILS_FOR_TASK_FAIL";

export const PARTICIPANT_STATUS_HISTORY = "PARTICIPANT_STATUS_HISTORY";
export const PARTICIPANT_STATUS_HISTORY_SUCCESS = "PARTICIPANT_STATUS_HISTORY_SUCCESS";
export const PARTICIPANT_STATUS_HISTORY_FAIL = "PARTICIPANT_STATUS_HISTORY_FAIL";

export const ADD_REMARK_ON_STATUS = "ADD_REMARK_ON_STATUS";
export const ADD_REMARK_ON_STATUS_SUCCESS = "ADD_REMARK_ON_STATUS_SUCCESS";
export const ADD_REMARK_ON_STATUS_FAIL = "ADD_REMARK_ON_STATUS_FAIL";

export const GET_MYNDIS_GOAL = "GET_MYNDIS_GOAL";
export const GET_MYNDIS_GOAL_SUCCESS = "GET_MYNDIS_GOAL_SUCCESS";
export const GET_MYNDIS_GOAL_FAIL = "GET_MYNDIS_GOAL_FAIL";
